import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API, apiClient as axios } from "../../lib/api";
import LeadDetailsModal from "../../components/LeadDetailsModal";
import { Button } from "../../components/ui";

export default function ViewLeadViaToken() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [lead, setLead] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();
    let cancelled = false;

    const load = async () => {
      try {
        const res = await axios.get(`${API}/leads/view/${token}`, {
          signal: abortController.signal
        });
        if (!cancelled) {
          setLead(res.data.data);
        }
      } catch (e) {
        if (e.name === 'CanceledError' || e.code === 'ERR_CANCELED') {
          return;
        }
        if (!cancelled) {
          setError(e?.response?.data?.error || "Invalid or expired token");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    load();

    return () => {
      cancelled = true;
      abortController.abort();
    };
  }, [token]);

  const handleClose = () => {
    const authToken = localStorage.getItem('token');
    if (authToken) {
      navigate('/admin');
    } else {
      navigate('/');
    }
  };

  if (error) {
    const authToken = localStorage.getItem('token');
    return (
      <div className="page">
        <div className="card">
          <div className="error" style={{ marginBottom: '16px' }}>{error}</div>
          <Button onClick={handleClose}>
            {authToken ? 'Return to Dashboard' : 'Go to Login'}
          </Button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="page">
        <div className="card">Loading…</div>
      </div>
    );
  }

  return (
    <LeadDetailsModal 
      lead={lead} 
      isOpen={true} 
      onClose={handleClose} 
    />
  );
}


